const e = Math.PI * 2;
function r(t) {
  return (t % e + e) % e;
}
function h(t, o) {
  let n = o - t;
  for (; n > Math.PI; ) n -= e;
  for (; n < -Math.PI; ) n += e;
  return n;
}
function i(t, o) {
  return 1 - Math.pow(1 - t, o * 60);
}
export {
  r as normalizeAngle,
  h as shortestAngleDiff,
  i as smoothLerp
};
//# sourceMappingURL=math.js.map
